<div class="task-detail-page-container">
    <hr class="line" [ngStyle]="{ background: newColor }" />
    <app-topnav [clientLogo]="clientLogo" pagename="Case Management" prName="Case Details"></app-topnav>

    <div class="task-detail-page-body">

        <loading *ngIf="isLoadingTask"></loading>

        <div *ngIf="!isLoadingTask && loadError" class="task-detail-error">
            <mat-icon>error_outline</mat-icon>
            <p>{{ loadError }}</p>
            <button mat-flat-button color="primary" (click)="onCancelled()">Go Back</button>
        </div>

        <ng-container *ngIf="!isLoadingTask && !loadError && taskData">
            <div class="task-detail-page-breadcrumb">
                <button mat-icon-button (click)="onCancelled()" matTooltip="Back to Tasks">
                    <mat-icon>arrow_back</mat-icon>
                </button>
                <span>Case Details | #{{ taskId }}</span>
            </div>

            <app-task-detail-content
                [taskData]="taskData"
                [context]="'page'"
                (saved)="onSaved($event)"
                (cancelled)="onCancelled()">
            </app-task-detail-content>
        </ng-container>
    </div>
</div>
